import { lazy } from "react";

// const StockSearchExploreV2 = lazy(() => import("features/Market/v2/Explore"));
// const StockSearchDetailsV2 = lazy(() => import("features/Market/v2/Details"));
const StockMoversV2 = lazy(() => import("features/Market/v2/StockMovers"));
const FearGreedIndexV2 = lazy(() =>
  import("features/Market/v2/FearGreedIndex")
);
const ResearchV2 = lazy(() => import("features/Research/v2/index"));
const StockDetailPage = lazy(() =>
  import("features/Research/v2/components/StockDetailPage")
);

export const STOCK_SEARCH_PATH = "/explore";
export const STOCK_SEARCH_DETAILS_PATH = "/explore/stock/:symbol/details";
export const STOCK_MOVERS_PATH = "/explore/stock-movers";
export const STOCK_FEAR_GREED_INDEX_PATH = "/explore/data";

// V2 Routes
export const MARKET_V2_PATH = "/markets";
export const MARKET_DETAILS_V2_PATH = "/markets/stock/:symbol/details";
export const MARKET_MOVERS_V2_PATH = "/markets/stock-movers";
export const MARKET_FEAR_GREED_INDEX_V2_PATH = "/markets/data";

export const marketRoutesV2 = [
  {
    path: MARKET_V2_PATH,
    // component: <StockSearchExploreV2 />,
    component: <ResearchV2 />,
  },
  {
    path: MARKET_DETAILS_V2_PATH,
    // component: <StockSearchDetailsV2 />,
    component: <StockDetailPage />,
  },
  {
    path: MARKET_MOVERS_V2_PATH,
    component: <StockMoversV2 />,
  },
  {
    path: MARKET_FEAR_GREED_INDEX_V2_PATH,
    component: <FearGreedIndexV2 />,
  },
];
